import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';



export class TrustResourceUrl implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) { }

  transform(value: any, ..._args: any[]): any {
    if (!value) {
      return null;
    }

    return this.sanitizer.bypassSecurityTrustResourceUrl(value);
  }
static decorators: DecoratorInvocation[] = [
{ type: Pipe, args: [{
  name: 'trustResourceUrl',
  pure: true
}, ] },
{ type: Injectable },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: DomSanitizer, },
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
